@if (isInitialized) {
    <div class="ws-flex-container-vertical ws-flex-auto">
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title">
                    Tax Access Sync Log
                    <ag-grid-row-count [gridApi]="gridApi" [gridOptions]="gridOptions"></ag-grid-row-count>
                </h4>
                <div class="ws-section__header__actions">
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary has-icon"
                                (click)="refresh()"
                                [disabled]="refreshing"
                                helpTooltip
                                helpContentId="app.refresh"
                                position="bottom">
                            <i class="fa fa-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)"
                            [gridId]="gridId"
                            [showConfigureLayout]="false">
        </ws-ag-grid-angular>
    </div>
}
